// separate file so the service doesnt get too busy

import { globalFields } from "./global-fields";


const exampleParent = {
    fields: [
        globalFields.vehicle.vehicleId,
        globalFields.vehicle.tags
    ],
    customFields: [

    ]
}

const entityType = {
    fields: [
        globalFields.vehicle.vehicleId,
        globalFields.vehicle.tags,
        {
            name: 'vehicleEntityType',
            label: 'Vehicle Entity Type',
            validators: {required: true}
        },
    ],
    customFields: [
    ]
};

const primaryInformation = {
    fields: [
        globalFields.vehicle.vehicleId,
        globalFields.vehicle.tags,
        globalFields.vehicle.itemType,
        {
            name: 'vehicleCategoryId',
            label: 'Vehicle Type Code',
            validators: {}
        },
        {
            name: 'vehicleManufacturerId',
            label: 'Make',
            validators: {}
        },
        {
            name: 'vehicleModelId',
            label: 'Model',
            validators: {}
        },
        {
            name: 'modelYear',
            label: 'Year',
            validators: {}
        },
        {
            name: 'vehicleColors',
            label: 'Vehicle Color',
            array: [
                {
                    name: 'vehicleColorCodeId',
                    label: 'Color Code',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'vehicleColorLocationId',
                    label: 'Color Location',
                    validators: {}
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                }
            ]
        },
        {
            name: 'vehicleRegistrations',
            label: 'Registration Information',
            array: [
                {
                    name: 'vehicleIdentifierTypeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'identifier',
                    label: 'Value',
                    validators: {
                        required: true,
                        maxlength: 20
                    }
                },
                {
                    name: 'usStateId',
                    label: 'State',
                    validators: {}
                },
                {
                    name: 'expiresOn',
                    label: 'Expiration Date',
                    validators: {
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                }
            ]
        },
        {
            name: 'vehicleIdentifications',
            label: 'Identification Number',
            array: [
                {
                    name: 'vehicleIdentifierTypeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'identifier',
                    label: 'Value',
                    validators: {
                        required: true,
                        maxlength: 20
                    }
                },
                {
                    name: 'usStateId',
                    label: 'State',
                    validators: {}
                },
                {
                    name: 'issuingAuthority',
                    label: 'Issuing Authority',
                    validators: {}
                },                
                {
                    name: 'issuedOn',
                    label: 'Issued On',
                    validators: {}
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                }
            ]
        }
    ],
    customFields: [
    ]
};

const landVehicle = {
    fields: [
        {
            name: 'plateType',
            label: 'Plate Type',
            validators: {}

        },
        {
            name: 'tagYear',
            label: 'Tag Year',
            validators: {}
        },
        {
            name: 'titleNumber',
            label: 'Title',
            validators: {}
        },
        {
            name: 'insuranceCompanyName',
            label: 'Insurance Company',
            validators: {}
        },
        {
            name: 'insurancePolicyNumber',
            label: 'Insurance Policy Number',
            validators: {}
        },
        {
            name: 'insurancePolicyStartDate',
            label: 'Policy Start Date',
            validators: {}
        },
        {
            name: 'insurancePolicyEndDate',
            label: 'Policy End Date',
            validators: {}
        },
    ],
    customFields: []
}

const waterVehicle = {
    fields: [
        {
            name: 'id',
            label: 'Id',
            validators: {}
        },
        {
            name: 'vehicleId',
            label: 'Vehicle Id',
            validators: {}
        },
        {
            name: 'watercraftUseTypeId',
            label: 'Use',
            validators: {}
        },
        {
            name: 'watercraftHullMaterialId',
            label: 'Hull Material',
            validators: {}
        },
        {
            name: 'watercraftVesselTypeId',
            label: 'Vessel Type',
            validators: {}
        },
        {
            name: 'watercraftPropulsionTypeId',
            label: 'Propulsion Type',
            validators: {}
        },
        {
            name: 'engineCount',
            label: '# Engines',
            validators: {}
        },
        {
            name: 'totalHorsepower',
            label: 'Horsepower',
            validators: {}
        },
        {
            name: 'engineManufacturer',
            label: 'Engine Manufacturer',
            validators: {}
        } ,
        {
            name: 'watercraftEngineTypeId',
            label: 'Engine Type',
            validators: {}
        } ,
        {
            name: 'fuelTypeId',
            label: 'Fuel Type',
            validators: {}
        },
        {
            name: 'watercraftLength',
            label: 'Length (Ft)',
            validators: {}
        },
        {
            name: 'watercraftDraftForward',
            label: 'Draft Forward (Ft)',
            validators: {}
        },
        {
            name: 'watercraftDraftAft',
            label: 'Draft Aft (Ft)',
            validators: {}
        },
        {
            name: 'watercraftBeam',
            label: 'Beam (Ft)',
            validators: {}
        },
        {
            name: 'watercraftWeight',
            label: 'Weight (Lbs)',
            validators: {}
        },
        {
            name: 'watercraftVesselName',
            label: 'Vessel Name',
            validators: {}
        },                    
        {
            name: 'uscgNumberVehicleIdentifier',
            label: 'USCG #',
            objects: {
                isStateAssigned: {
                    name: 'isStateAssigned',
                    label: 'State Assigned',
                    validators: {} 
                },
                identifier: {
                    name: 'identifier',
                    label: 'Identification Id',
                    validators: {} 
                },
                issuedOn: {
                    name: 'issuedOn',
                    label: 'Date Issued',
                    validators: {} 
                },
                expiresOn: {
                    name: 'expiresOn',
                    label: 'Expiration Date',
                    validators: {} 
                },
                isExpired: {
                    name: 'isExpired',
                    label: 'Expired',
                    validators: {} 
                },
                description: {
                    name: 'description',
                    label: 'Description',
                    validators: {} 
                },
                issuingAuthorityId: {
                    name: 'issuingAuthorityId',
                    label: 'Issuing Authority',
                    validators: {} 
                },
                vehicleIdentifierStatusId: {
                    name: 'vehicleIdentifierStatusId',
                    label: 'Identifier Status',
                    validators: {} 
                },
                vehicleIdentifierSubTypeId: {
                    name: 'vehicleIdentifierSubTypeId',
                    label: 'Identification Id',
                    validators: {} 
                },
                vehicleIdentifierTypeId: {
                    name: 'vehicleIdentifierTypeId',
                    label: 'Identifier Type Id',
                    validators: {} 
                },
                vehicleId: {
                    name: 'vehicleId',
                    label: 'Item Id',
                    validators: {} 
                },
                id: {
                    name: 'id',
                    label: ''
                }
            }          
        },
        globalFields.vehicle.vehicleId,
    ],
    customFields: []
};

const fleetDetails = {
  fields: [
    {
      name: 'isMarkedVehicle',
      label: 'Marked Vehicle',
      validators: {},
    },

    {
      name: 'unitTypeId',
      label: 'Unit Type',
      validators: {},
    },

    {
      name: 'vehicleMarkId',
      label: 'Vehicle ID',
      validators: {},
    },
    {
      name: 'isVehicleActive',
      label: 'Active Vehicle',
      validators: {},
    },
  ],
  customFields: [],
};

export const vehicleExampleFields = {
    fields: [...exampleParent.fields],
    customFields: [...exampleParent.customFields]
}

export const vehicleEntityTypeFields = {
    fields: [...entityType.fields],
    customFields: [...entityType.customFields]
};

export const vehiclePrimaryInformationFields = {
    fields: [...primaryInformation.fields],
    customFields: [...primaryInformation.customFields]
};

export const vehicleLandVehicleFields = {
    fields: [...landVehicle.fields],
    customFields: [...landVehicle.customFields]
};

export const vehicleWaterVehicleFields = {
    fields: [...waterVehicle.fields],
    customFields: [...waterVehicle.customFields]
}

export const vehicleFleetDetailsFields = {
    fields: [...fleetDetails.fields],
    customFields: [...fleetDetails.customFields]
}



export const vehiclePersonAssociationFields = {
    fields: [
        globalFields.person.lastName,
        globalFields.person.firstName,
        globalFields.person.middleName,
        globalFields.person.suffix,
        globalFields.person.unnamed,
        globalFields.person.race,
        globalFields.person.sex,
        globalFields.person.gender,
        globalFields.person.ethnicity,        
        globalFields.person.id,
        globalFields.address.primaryAddress
    ]
}

export const vehicleIncidentAssociationFields = {
    fields: [
        globalFields.incident.logNumber,
        globalFields.incident.incidentReportType,
        globalFields.incident.reportedOn,
        globalFields.incident.occurredOn,
        globalFields.incident.location,
        globalFields.incident.agency,
        globalFields.incident.age,
        globalFields.incident.involvement,
        globalFields.incident.linkDate,
        globalFields.incident.disposition,
        globalFields.incident.comment,
    ],
    customFields: []
};